import { render, staticRenderFns } from "./WorkList.vue?vue&type=template&id=55c5c32b"
import script from "./WorkList.vue?vue&type=script&lang=js"
export * from "./WorkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports